export default {"src":"/_next/static/media/Quote-Marks.7c994974.svg","height":31,"width":31};